/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Go_To_Sign_InInputs */

const fr_auth_go_to_sign_in = /** @type {(inputs: Auth_Go_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la connexion`)
};

const en_auth_go_to_sign_in = /** @type {(inputs: Auth_Go_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to sign-in`)
};

/**
* | output |
* | --- |
* | "Back to sign-in" |
*
* @param {Auth_Go_To_Sign_InInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_go_to_sign_in = /** @type {((inputs?: Auth_Go_To_Sign_InInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Go_To_Sign_InInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_go_to_sign_in(inputs)
	return fr_auth_go_to_sign_in(inputs)
});